import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0ae5709e&scoped=true&"
import script from "./Header.vue?vue&type=script&defer=true&lang=js&"
export * from "./Header.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./Header.vue?vue&type=style&index=0&id=0ae5709e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae5709e",
  null
  
)

export default component.exports